import { CollectionsLobbyGrafanaEvents } from '../../../../page/collections_lobby/utils/events/grafana';
import { CollectionPageGrafanaEvents } from '../../../../page/collection_page/utils/events/grafana';
import { EventTypes } from '../types';
import { createGrafanaEvent } from './base';

const { modals, collection } = EventTypes.shared;
const { shareWithTeam, socialShare, deleteConfirmation, editCollection } = modals;

export const GrafanaEvents = {
    ...CollectionsLobbyGrafanaEvents,
    ...CollectionPageGrafanaEvents,

    [shareWithTeam.show]: createGrafanaEvent('share_with_team_modal.show'),
    [shareWithTeam.cancel]: createGrafanaEvent('share_with_team_modal.cancel'),
    [shareWithTeam.submit]: createGrafanaEvent('share_with_team_modal.submit'),
    [shareWithTeam.fail]: createGrafanaEvent('share_with_team_modal.fail'),

    [socialShare.show]: createGrafanaEvent('social_sharing_modal.show'),

    [deleteConfirmation.show]: createGrafanaEvent('delete_confirmation_modal.show'),
    [deleteConfirmation.cancel]: createGrafanaEvent('delete_confirmation_modal.cancel'),
    [deleteConfirmation.submit]: createGrafanaEvent('delete_confirmation_modal.submit'),
    [deleteConfirmation.fail]: createGrafanaEvent('delete_confirmation_modal.fail'),

    [editCollection.show]: createGrafanaEvent('edit_collection_modal.show'),
    [editCollection.cancel]: createGrafanaEvent('edit_collection_modal.cancel'),
    [editCollection.submit]: createGrafanaEvent('edit_collection_modal.submit'),
    [editCollection.fail]: createGrafanaEvent('edit_collection_modal.fail'),

    [collection.create.success]: createGrafanaEvent('collection.created'),
    [collection.update.success]: createGrafanaEvent('collection.updated'),
    [collection.delete.success]: createGrafanaEvent('collection.deleted'),
    [collection.shareWithTeam.success]: createGrafanaEvent('collection.shared_with_team'),
};
